import { gql } from '@apollo/client'

export const CREATE_CUSTOMER = gql`
  mutation ($customer: NewCustomerInput!) {
    createCustomer(customer: $customer) {
      _id
      name
      business_identity_code
      contacts {
        _id
        name
        email
        job_title
        phone
      }
      tes_name
      city

      assignments {
        _id
        name
      }
      employees {
        _id
        assignment_ids
        hour_rate
      }
      _employees {
        _id
        first_name
        last_name
      }
    }
  }
`

export const QUERY_CUSTOMERS = gql`
  query ($employee_id: String) {
    customers(employee_id: $employee_id) {
      _id
      name
      business_identity_code
      contacts {
        _id
        name
        email
        job_title
        phone
      }
      tes_name
      city
      assignments {
        _id
        name
      }
      employees {
        _id
        assignment_ids
        hour_rate
      }
      _employees {
        _id
        first_name
        last_name
      }
    }
  }
`

export const UPDATE_CUSTOMER = gql`
  mutation ($customer: CustomerInput!) {
    updateCustomer(customer: $customer) {
      _id
      name
      business_identity_code
      contacts {
        _id
        name
        email
        job_title
        phone
      }
      tes_name
      city
      assignments {
        _id
        name
      }
      employees {
        _id
        assignment_ids
        hour_rate
      }
      _employees {
        _id
        first_name
        last_name
      }
    }
  }
`

export const DELETE_CUSTOMER = gql`
  mutation ($_id: String!) {
    deleteCustomer(_id: $_id)
  }
`
